import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { bootstrapApplication } from '@angular/platform-browser';
import { CoreComponent } from '@core/components/core/core.component';
import { appConfig } from '@core/app.config';

registerLocaleData(localeFr, 'fr');

bootstrapApplication(CoreComponent, appConfig).catch((err) => {
  // eslint-disable-next-line no-console
  console.error(err);
});
